'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const NotesIcon = createIcon({
    displayName: 'NotesIcon',
    viewBox: '0 0 16 16',
    fill: 'none',
    path: (
        <path
            d="M8.667 2.533v1.8c0 1.12 0 1.68.218 2.108a2 2 0 00.874.874c.428.218.988.218 2.108.218h1.8M14 8.86v2.14c0 1.12 0 1.681-.218 2.109a2 2 0 01-.874.874c-.428.218-.988.218-2.108.218H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 01-.874-.874C2 12.68 2 12.12 2 11V5.4c0-1.12 0-1.68.218-2.108a2 2 0 01.874-.874C3.52 2.2 4.08 2.2 5.2 2.2h2.141c.49 0 .734 0 .964.055a2 2 0 01.578.24c.202.123.375.296.72.642l3.46 3.459c.346.346.519.519.642.72.11.18.19.375.24.579.055.23.055.474.055.964z"
            stroke="currentColor"
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    ),
})

export default NotesIcon
